import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OfflineDialogComponent} from './offline-dialog/offline-dialog.component';
import {PlaybackDialogComponent} from './playback-dialog/playback-dialog.component';
import {ProgressDialogComponent} from './progress-dialog/progress-dialog.component';
import {SyncDialogComponent} from './sync-dialog/sync-dialog.component';
import {UpdateRefreshDialogComponent} from './update-refresh-dialog/update-refresh-dialog.component';
import {VolumeDialogComponent} from './volume-dialog/volume-dialog.component';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatCardModule} from '@angular/material/card';
import {FormsModule} from '@angular/forms';
import {SettingsDialogComponent} from './settings-dialog/settings-dialog.component';
import {SharedModule} from '../../shared.module';
import {LanguageDialogComponent} from './settings-dialog/language-dialog/language-dialog.component';
import {InformationDialogComponent} from './settings-dialog/information-dialog/information-dialog.component';
import {SonosComponent} from '../../containers/player/sonos/sonos.component';
import {MatRippleModule} from '@angular/material/core';
import {MatRadioModule} from '@angular/material/radio';
import {HelpComponent} from '../../containers/side-panel/help/help.component';
import {SyncConfirmComponent} from './settings-dialog/sync-confirm/sync-confirm.component';
import {MatButtonModule} from '@angular/material/button';
import {ButtonsModule} from '../buttons/buttons.module';
import {MatDialogModule} from '@angular/material/dialog';


@NgModule({
  declarations: [
    OfflineDialogComponent,
    PlaybackDialogComponent,
    ProgressDialogComponent,
    SyncDialogComponent,
    UpdateRefreshDialogComponent,
    VolumeDialogComponent,
    SettingsDialogComponent,
    LanguageDialogComponent,
    SonosComponent,
    InformationDialogComponent,
    HelpComponent,
    SyncConfirmComponent
  ],
  exports: [
    ProgressDialogComponent
  ],
  imports: [
    CommonModule,
    // BrowserModule,  TODO :: Remove comments once validated
    MatIconModule,
    MatProgressSpinnerModule,
    MatCardModule,
    SharedModule,
    FormsModule,
    MatRippleModule,
    MatRadioModule,
    MatButtonModule,
    ButtonsModule,
    MatDialogModule
  ]
})
export class DialogsModule {
}
